import { useState } from "react";
import "../../assets/css/application.scss";

function ServicePage() {
  const [openSections, setOpenSections] = useState({
    "sec-1": true,
    "sec-2": true,
    "sec-3": true,
    "sec-4": true,
    "sec-5": true,
    "sec-6": true,
    "sec-7": true,
    "sec-8": true,
    "sec-9": true,
    "sec-10": true,
    "sec-11": true,
    "sec-12": true,
    "sec-13": true,
  });

  const toggleAccordion = (sectionId) => {
    setOpenSections((prev) => ({
      ...prev,
      [sectionId]: !prev[sectionId],
    }));
  };

  const AccordionSection = ({ id, title, children, isOpen }) => (
    <section
      className={`policy-section accordion ${isOpen ? "open" : ""}`}
      id={id}
    >
      <button onClick={() => toggleAccordion(id)} aria-expanded={isOpen}>
        {title}
      </button>
      <div data-panel style={{ display: isOpen ? "block" : "none" }}>
        {children}
      </div>
    </section>
  );

  return (
    <div className="service-wrap">
      <header>
        <div className="brand">
          <div className="brand-logo">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                d="M6 12h12M6 16h8"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="brand-text">
            <h1>키즈다 — 이용약관</h1>
            <p>최종 업데이트: 2025년 9월 15일</p>
          </div>
        </div>
        <a href="#toc" className="btn">
          목차 바로가기
        </a>
      </header>

      <div className="container">
        <main>
          <h2 className="doc-title">이용약관</h2>
          <br />

          <AccordionSection
            id="sec-1"
            title="제 1 조 목적"
            isOpen={openSections["sec-1"]}
          >
            <p style={{ fontSize: "small" }}>
              이 약관은 키즈다(이하 회사)가 제공하는 모든 서비스(이하 서비스)를
              이용하는 고객(이하 회원)과 회사가 서비스의 이용조건 및 절차,
              권리와 의무, 기타 필요한 사항을 규정함을 목적으로 합니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-2"
            title="제 2 조 약관의 효력과 변경"
            isOpen={openSections["sec-2"]}
          >
            <p style={{ fontSize: "small" }}>
              1. 서비스는 본 약관에 규정된 조항을 회원이 수락하는 것을 조건으로
              제공되며 회원이 회원가입시 "동의" 단추를 누름과 동시에 이 약관에
              동의하는 것으로 간주됩니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 이 약관은 온라인을 통해 공시함으로써 효력을 발생합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              3. 회사는 불가피한 변경의 사유가 있을 때 약관을 임의로 변경할
              권한을 가지며 변경된 약관은 온라인을 통해 공지됨으로써 효력이
              발생됩니다.
            </p>
            <p style={{ fontSize: "small" }}>
              4. 회원은 변경된 약관에 동의하지 않을 경우 탈퇴를 요청할 수 있으며
              변경된 약관의 효력발생일 이후에도 계속적으로 서비스를 이용하는
              경우에는 회원이 약관의 변경 사항에 동의한 것으로 봅니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-3"
            title="제 3 조 약관 외 준칙"
            isOpen={openSections["sec-3"]}
          >
            <p style={{ fontSize: "small" }}>
              이 약관에 명시되지 않은 사항에 대해서는 국내 관련 법령 규정에
              따릅니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-4"
            title="제 4 조 이용계약의 체결"
            isOpen={openSections["sec-4"]}
          >
            <p style={{ fontSize: "small" }}>
              1. 이용계약은 회원의 회원가입신청을 회사가 승낙 함으로써
              성립합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 회사는 신청서의 내용이 허위이거나 규정한 제반 사항을 위반하여
              신청한 경우 가입 신청을 거절할 수 있습니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-5"
            title="제 5 조 이용계약의 해지"
            isOpen={openSections["sec-5"]}
          >
            <p style={{ fontSize: "small" }}>
              1. 회원은 회사에 언제든 이용계약의 해지를 요청할 수 있습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 회사는 회원의 해지 요청이 접수된 즉시 회원을 탈퇴 처리 하고
              관련 법령 및 개인정보처리방침에 명시된 경우를 제외한 개인정보를
              삭제합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              3. 회사는 회원이 제9조 회원의 의무에 위배되는 행위를 한 경우
              사전통지 없이 이용계약의 해지, 제한, 정지할 수 있습니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-6"
            title="제 6 조 서비스"
            isOpen={openSections["sec-6"]}
          >
            <p style={{ fontSize: "small" }}>
              1. 회사는 다음과 같은 서비스를 제공합니다.
            </p>
            <ul className="clean">
              <li style={{ fontSize: "small" }}>
                뉴스 서비스, 온라인 강의 제휴 서비스
              </li>
            </ul>
            <br />
            <p style={{ fontSize: "small" }}>
              2. 회사는 필요한 경우 서비스 내용을 추가, 변경, 삭제할 수
              있습니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-7"
            title="제 7 조 회사의 의무"
            isOpen={openSections["sec-7"]}
          >
            <p style={{ fontSize: "small" }}>
              1. 회사는 지속적, 안정적으로 서비스가 제공되도록 최선의 노력을
              다하여야 합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 회사는 24시간 365일 서비스 제공을 원칙으로 합니다. 다만
              정기점검, 천재지변, 비상사태 등 부득이한 사유가 발생한 경우
              서비스를 일시 중단할 수 있습니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-8"
            title="제 8 조 개인정보의 보호"
            isOpen={openSections["sec-8"]}
          >
            <p style={{ fontSize: "small" }}>
              1. 회사는 서비스와 관련하여 수집된 회원의 개인정보를 본인의 사전
              승낙없이 제3자에게 공개 또는 배포할 수 없습니다. 다만 관련 법령에
              의한 관계기관의 요구가 있을 경우 그러하지 아니합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 회사는 개인정보 보호책임자를 비롯한 개인정보에 관한 기타 사항을
              별도로 정한 "개인정보처리방침"에 기재하여 공지합니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-9"
            title="제 9 조 회원의 의무"
            isOpen={openSections["sec-9"]}
          >
            <p style={{ fontSize: "small" }}>
              1. ID와 비밀번호에 관한 관리책임은 회원에게 있습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 회원은 자신의 ID를 제3자에게 양도, 대여할 수 없습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              3. 회원은 자신의 ID가 부정하게 사용된 경우 반드시 회사에
              통보하여야 합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              4. 회원은 회원가입시 입력항목에 허위, 오기, 누락이 없도록 하여야
              합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              5. 회원은 제3자의 권리나 저작권 등을 침해하는 행위를 할 수
              없습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              6. 회원은 이 약관 및 관계법령에서 규정한 사항을 준수하여야 하며
              기타 회사의 업무에 방해되는 행위를 하여서는 안됩니다.
            </p>
            <p style={{ fontSize: "small" }}>
              7. 회원은 회사의 사전 승낙없이 서비스를 이용하여 어떠한 영리행위도
              할 수 없습니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-10"
            title="제 10 조 저작권"
            isOpen={openSections["sec-10"]}
          >
            <p style={{ fontSize: "small" }}>
              1. 회사의 모든 서비스에 대한 저작권은 회사 및 회사에 콘텐츠를
              제공하는 제공처, 광고주에 있습니다. 이 모든 저작물은 저작권법 및
              관계 법령에 의해 보호받으며 회사, 콘텐츠 제공처, 광고주의 사전
              승낙 없이 복제, 출판, 전송, 배포, 방송 기타 방법에 의하여
              이용하거나 제3자에게 이용하게 할 수 없으며, 저작물에 대한 저작권
              침해는 관계 법령의 적용을 받습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 회사는 회원이 서비스내의 기사의견, 게시판 등에 올린 내용에 대해
              책임이 없습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              3. 회사는 저작권에 관한 기타 사항을 별도로 정한 "저작권정책"에
              기재하여 공지합니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-11"
            title="제 11 조 기타"
            isOpen={openSections["sec-11"]}
          >
            <p style={{ fontSize: "small" }}>
              본 약관은 공정거래위원회 표준 약관에 근거하여 작성되었습니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-12"
            title="제 12 조 구독 결제 및 환불"
            isOpen={openSections["sec-12"]}
          >
            <p style={{ fontSize: "small" }}>
              본 환불 정책은 (주)위고컴퍼니가 운영하는 키즈다 앱 서비스의
              웹사이트(PG 연동 결제)를 통한 유료 구독 결제에 적용됩니다. 인앱
              결제(앱스토어)는 앱스토어의 환불 규정을 따릅니다.
            </p>
            <br />
            <span style={{ fontSize: "small" }}>
              <strong>결제 방법</strong>
            </span>
            <ul className="clean">
              <p style={{ fontSize: "small" }}>
                1. 이용자는 다음 방법으로 구독 서비스를 결제할 수 있습니다.
              </p>
              <p style={{ fontSize: "small" }}>
                2. 모바일 앱 내 인앱 결제 (Apple App Store, Google Play Store)
              </p>
              <p style={{ fontSize: "small" }}>
                3. 회사 웹사이트를 통한 PG(결제대행) 결제
              </p>
            </ul>
            <br />
            <span style={{ fontSize: "small" }}>
              <strong>애플 앱스토어 인앱 결제 환불 정책</strong>
            </span>
            <ul className="clean">
              <p style={{ fontSize: "small" }}>
                1. 애플 모바일 앱 인앱 결제는 해당 스토어 'Apple App Store' 의
                정책에 따라 환불이 진행됩니다.
              </p>
              <p style={{ fontSize: "small" }}>
                2. 애플 인앱 결제 환불 요청은 이용자가 직접 앱스토어
                고객지원센터를 통해 신청해야 하며, 회사는 인앱 결제에 대한
                환불을 별도로 처리하지 않습니다.
              </p>
              <p style={{ fontSize: "small" }}>
                3. 스토어 환불 정책에 따라 환불 가능 여부 및 환불 금액이
                결정됩니다.
              </p>
            </ul>
            <br />
            <span style={{ fontSize: "small" }}>
              <strong>Google Play Store 및 PG 결제 환불 정책</strong>
            </span>
            <p style={{ fontSize: "small" }}>
              Google Play Store 및 회사 웹사이트를 통한 PG 결제 구독에 대해서는
              다음 환불 기준이 적용됩니다.
            </p>
            <br />
            <ul className="clean">
              <p style={{ fontSize: "small" }}>
                <strong>[구독 30일]</strong>
              </p>
              <li style={{ fontSize: "small" }}>
                결제일로부터 7일 이내 & 콘텐츠 미이용 시: 전액 환불
              </li>
              <li style={{ fontSize: "small" }}>
                7일 경과 또는 콘텐츠 일부 이용 시: 환불 불가
              </li>
            </ul>
            <br />
            <ul className="clean">
              <p style={{ fontSize: "small" }}>
                <strong>[구독 90일]</strong>
              </p>
              <li style={{ fontSize: "small" }}>
                결제일로부터 7일 이내 & 콘텐츠 미이용 시: 전액 환불
              </li>
              <li style={{ fontSize: "small" }}>
                7일 초과 시 : 사용 개월 수만큼 정가(월 1만원) 차감 후 잔여기간
                환불
              </li>
              <li style={{ fontSize: "small" }}>
                예시) 7일 초과시 당월분 (1개월) 서비스 이용, 남은 (2개월)
                잔여기간 환불
              </li>
            </ul>
            <br />
            <ul className="clean">
              <p style={{ fontSize: "small" }}>
                <strong>[구독 365일]</strong>
              </p>
              <p style={{ fontSize: "small" }}>
                (총 결제 금액: 108,000원 / 10% 할인 적용)
              </p>
              <li style={{ fontSize: "small" }}>
                결제일로부터 7일 이내 & 콘텐츠 미이용 시: 전액 환불
              </li>
              <li style={{ fontSize: "small" }}>
                7일 초과 시 : 사용 개월 수만큼 정가(월 1만원) 차감 후 잔여기간
                환불
              </li>
              <li style={{ fontSize: "small" }}>
                예시) 7일 초과시 당월분 (1개월) 서비스 이용, 남은 (11개월)
                잔여기간 환불
              </li>
              <li style={{ fontSize: "small" }}>
                사용 개월 수 x 1만원(정가) 차감 + 할인분(12,000원) 차감 후
                잔여금 환불 (즉, 환불 시 할인 혜택은 소급 취소됨)
              </li>
              <br />
              <span style={{ fontSize: "small" }}>(예시)</span>
              <li style={{ fontSize: "small" }}>
                1년365일권 결제 후 90일 사용 → 차감액: 3만원
              </li>
              <li style={{ fontSize: "small" }}>
                할인 혜택 취소 → 추가 차감 12,000원
              </li>
              <li style={{ fontSize: "small" }}>
                최종 환불액 : 108,000 - 30,000 - 12,000 = 66,000원
              </li>
            </ul>
            <br />
            <ul className="clean">
              <p style={{ fontSize: "small" }}>
                <strong>[에듀클립]</strong>
              </p>
              <p style={{ fontSize: "small" }}>
                회사의 본 약관상 환불규정 등은 "약관의 규제에 관한 법률",
                "온라인 디지털콘텐츠산업 발전법", "전자상거래 등에서의
                소비자보호에 관한 법률" 등을 반영하였습니다. 전 항의 관계법령에
                따른 소비자의 청약철회가 불가능한 경우로는,
              </p>
              <li style={{ fontSize: "small" }}>
                청약철회가 불가능한 콘텐츠에 대한 사실을 표시사항에 포함한 경우
              </li>
              <li style={{ fontSize: "small" }}>시용상품을 제공한 경우</li>
              <li style={{ fontSize: "small" }}>
                한시적 또는 일부이용 등의 방법을 제공한 경우 등이 있습니다.
              </li>
              <li style={{ fontSize: "small" }}>
                회사는 본 조 제2항 제2호에 해당하는 사유인 '시용상품'을 제공하고
                있으며 '강좌 맛보기'등이 이에 해당합니다.
              </li>
              <br />
              <span style={{ fontSize: "small" }}>
                3강 이상으로 구성된 강좌
              </span>
              <li style={{ fontSize: "small" }}>
                3강 이상으로 구성된 강좌는 승인일로부터 10일 이내에 강좌맛보기를
                제외한 1강 이하 수강 시에 환불을 요청하시면 전액환불이
                가능합니다.
              </li>
            </ul>
            <br />
            <span style={{ fontSize: "small" }}>
              <strong>환불 절차 및 유의사항</strong>
            </span>
            <p style={{ fontSize: "small" }}>
              1. 환불은 고객센터 이메일 또는 앱내 문의 페이지를 통해 신청
              가능합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 환불 요청 시 결제자 정보와 환불 계좌 또는 카드번호가
              필요합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              3. 환불 처리 기간 영업일 기준 5~7일 이내
            </p>
            <p style={{ fontSize: "small" }}>
              4. 회사는 환불 요청 시 본인 확인을 위해 본인 인증을 요구할 수
              있습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              5. 결제 대행사(PG사)의 결제 수수료는 회사가 부담하며, 별도
              차감되지 않습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              6. 콘텐츠 이용 여부 판단은 로그인 기록 및 콘텐츠 열람 이력
              기준으로 합니다.
            </p>
            <br />
            <p style={{ fontSize: "small" }}>
              <strong>자동 갱신 안내 및 해지</strong>
            </p>
            <p style={{ fontSize: "small" }}>
              1. 인앱 결제 정기구독은 자동 갱신되며, 갱신일 기준 최소 3일전 해지
              신청 시 다음 결제는 진행되지 않습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 해지 시점까지 이용한 기간만큼은 정상 청구되며, 잔여기간에 대한
              환불은 위 기준에 따릅니다.
            </p>
          </AccordionSection>

          <AccordionSection
            id="sec-13"
            title="제 13 조 NIE 캠페인 기부금"
            isOpen={openSections["sec-13"]}
          >
            <p style={{ fontSize: "small" }}>
              본 정책은 (주)동아이지에듀가 운영하는 어린이동아 웹사이트(PG 연동
              결제)를 통한 NIE 캠페인 기부금 결제에 적용됩니다.
            </p>
            <br />
            <span style={{ fontSize: "small" }}>
              <strong>결제 방법</strong>
            </span>
            <p style={{ fontSize: "small" }}>
              1. 이용자는 다음 방법으로 NIE 캠페인에 참여 기부할 수 있습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 회사 웹사이트를 통한 PG(결제대행) 결제
            </p>
            <p style={{ fontSize: "small" }}>
              3. 결제수단 : 신용카드(정기결제 O), 계좌이체(정기결제 X)
            </p>
            <br />
            <span style={{ fontSize: "small" }}>
              <strong>기부금 결제 환불 정책</strong>
            </span>
            <p style={{ fontSize: "small" }}>
              NIE 캠페인 기부에 대해서는 다음 환불 기준이 적용됩니다.
            </p>
            <p style={{ fontSize: "small" }}>
              1. 선별된 기부 단체에 이미 기부가 진행된 경우 환불이 불가합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 기부금 결제일 이내 환불문의 시 검토 후 환불 조치가 가능합니다.
            </p>
            <br />
            <span style={{ fontSize: "small" }}>
              <strong>기부금 환불 절차 및 유의사항</strong>
            </span>
            <p style={{ fontSize: "small" }}>
              기부단체에 후원이 진행된 경우 환불이 불가합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              1. 환불은 고객센터 이메일 또는 앱내 문의 페이지를 통해 신청
              가능합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 환불 요청 시 결제자 정보와 환불 계좌 또는 카드번호가
              필요합니다.
            </p>
            <p style={{ fontSize: "small" }}>
              3. 환불 처리 기간 영업일 기준 5~7일 이내
            </p>
            <p style={{ fontSize: "small" }}>
              4. 회사는 환불 요청 시 본인 확인을 위해 본인 인증을 요구할 수
              있습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              5. 결제 대행사(PG사)의 결제 수수료는 회사가 부담하며, 별도
              차감되지 않습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              6. 콘텐츠 이용 여부 판단은 로그인 기록 및 콘텐츠 열람 이력
              기준으로 합니다.
            </p>
            <br />
            <span style={{ fontSize: "small" }}>
              <strong>자동 갱신 안내 및 해지</strong>
            </span>
            <p style={{ fontSize: "small" }}>
              NIE 캠페인 기부에 대해서는 다음 환불 기준이 적용됩니다.
            </p>
            <p style={{ fontSize: "small" }}>
              1. 정기결제 기부 시 갱신일 기준 최소 3일전 해지 신청 시 다음
              결제는 진행되지 않습니다.
            </p>
            <p style={{ fontSize: "small" }}>
              2. 해지 시점까지 이용한 기간만큼은 정상 청구되며, 잔여기간에 대한
              환불은 위 기준에 따릅니다.
            </p>
          </AccordionSection>
        </main>

        <aside className="privacy-aside" id="toc">
          <nav className="toc">
            <h4>문서 목차</h4>
            <ul>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-1">제 1 조 - 목적</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-2">제 2 조 - 약관의 효력과 변경</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-3">제 3 조 - 약관 외 준칙</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-4">제 4 조 - 이용계약의 체결</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-5">제 5 조 - 이용계약의 해지</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-6">제 6 조 - 서비스</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-7">제 7 조 - 회사의 의무</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-8">제 8 조 - 개인정보의 보호</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-9">제 9 조 - 회원의 의무</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-10">제 10 조 - 저작권</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-11">제 11 조 - 기타</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-12">제 12 조 - 구독 결제 및 환불</a>
              </li>
              <li style={{ fontSize: "small" }}>
                <a href="#sec-13">제 13 조 - NIE 캠페인 기부금</a>
              </li>
            </ul>
          </nav>
        </aside>
      </div>
    </div>
  );
}

export default ServicePage;
